import { formatZonedDateTime } from '@shared/lib/datetime/time-zone'

type BuildInfo = {
  version: string
  gitSha: string
  gitBranch: string
  builtAtIso: string
}

declare const __APP_BUILD_INFO__: BuildInfo

export const buildInfo = __APP_BUILD_INFO__

export function formatBuildTimestamp(iso: string) {
  const date = new Date(iso)

  if (Number.isNaN(date.getTime())) {
    return iso
  }

  return formatZonedDateTime(date, { dateStyle: 'short', timeStyle: 'short' })
}
